import { ReportType } from "../api/biClient.types";

export const chartRelatedReportTypes = [
  ReportType.AreaChart,
  ReportType.BarChart,
  ReportType.DoughnutChart,
  ReportType.LineChart,
  ReportType.PieChart,
  ReportType.TreeMapChart,
];
